import cx from 'classnames';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Rating from '@components/@core/Rating';
import { AverageTooltip } from '@components/ScorecardToolTips';

const AverageScore = ({ className, data }) => (
    <div className={cx(className, 'd-flex flex-column ai-start')}>
        <p className="dsl-b14 text-500 mb-2">Average Score</p>
        <OverlayTrigger placement="right" overlay={AverageTooltip(data)}>
            <div>
                {Number(data?.completed_average_star_score?.stars) > 0 ? (
                    <Rating className="cursor-pointer" score={data?.completed_average_star_score?.stars} size="small" />
                ) : (
                    <span className="dsl-m12">Incomplete</span>
                )}
            </div>
        </OverlayTrigger>
        <p className="dsl-b12 mt-2">
            {data?.reviews_completed?.count}/{data?.scorecards?.count} Reviews completed
        </p>
    </div>
);

export default AverageScore;
